<template>
    <div
        class="l-ss-c-results-info-tips-wrapper"
        :class="{ 'l-ss-c-results-info-tips-wrapper-scroll-end': isScrollToEnd }">
        <taps
            class="l-ss-c-results-info-tips"
            ref="tapsContainer"
            :query="search.query"
            :data="tips"
            :count="10"
            @scroll.native="onScroll"
            @result-tab-click="$emit('result-tab-click', $event)"
            @handle-tags-click="(value) => $emit('handle-tags-click', value)"/>
    </div>
</template>

<script>
    import { onMounted, ref } from '@vue/composition-api';

    import Taps from '@/core/components/taps.vue';

    const SCROLL_END_OFFSET = 10;

    export default {
        components: { Taps },
        props: {
            search: {
                type: Object,
            },
        },
        setup(props, { refs }) {
            const isScrollToEnd = ref(false);

            const tips = props.search.tips;

            onMounted(() => {
                onScroll();
            });

            const onScroll = () => {
                const { scrollWidth, scrollLeft, clientWidth } = refs.tapsContainer.$el;

                isScrollToEnd.value = scrollWidth - SCROLL_END_OFFSET < scrollLeft + clientWidth;
            };

            return {
                tips,
                isScrollToEnd,
                onScroll,
            };
        },
    };
</script>

<style scoped>

</style>
